import enviromment from '../environment';

const keys = {
    desktopMenuAberto: btoa('uninterDesktopMenuAberto_' + enviromment.ambiente)
}

export default class AplicacaoService {

    static setDesktopMenuAberto(state) {
        localStorage.setItem(keys.desktopMenuAberto, state ? 1 : 0);
        return state;
    }

    static getDesktopMenuAberto() {
        const item = localStorage.getItem(keys.desktopMenuAberto);
        return item !== null ? item === '1' : true;
    }
}